export default "__VITE_ASSET__Dds2oE65__"